module.exports = __webpack_public_path__ + "static/cv-bde884aa31b3870ac51d77833cf1ddb6.svg";